import { createContext, type ReactNode, useContext, useState } from "react";
import { type Libraries, LoadScript } from "@react-google-maps/api";
import { GOOGLE_GEOAPI_KEY } from "~/utils/constants";
import { useOnMount } from "~/common/hooks/useOnMount";

const GoogleApiLoadedContext = createContext<{ isLoaded: boolean; isError: boolean }>({
  isError: false,
  isLoaded: false,
});

const LIBRARIES: Libraries = ["places"];

export const GoogleApiProvider = ({ children }: { children?: ReactNode }) => {
  const [mounted, setMounted] = useState(false);
  useOnMount(() => {
    // Adding a delay to loading google maps prevents issues with emotion css-in-js dropping all the styles
    window.setTimeout(() => {
      setMounted(true);
    }, 1000);
  });
  const [state, setState] = useState({ isLoaded: false, isError: false });

  return (
    <GoogleApiLoadedContext.Provider value={state}>
      {mounted && (
        <LoadScript
          googleMapsApiKey={GOOGLE_GEOAPI_KEY}
          language={window.SCHA.config.language}
          libraries={LIBRARIES}
          preventGoogleFontsLoading={true}
          version={"3"}
          onLoad={() => setState({ isLoaded: true, isError: false })}
          onError={() => setState({ isLoaded: false, isError: true })}
        />
      )}
      {children}
    </GoogleApiLoadedContext.Provider>
  );
};

export const useIsGoogleApiLoaded = () => useContext(GoogleApiLoadedContext);
